import { render, staticRenderFns } from "./DocumentValidator.vue?vue&type=template&id=be098c44&scoped=true&"
import script from "./DocumentValidator.vue?vue&type=script&lang=ts&"
export * from "./DocumentValidator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be098c44",
  null
  
)

export default component.exports